export default __webpack_public_path__ + "static/orangeloop-migliorare-life-work-balance-guida-per-sviluppatori-f11519b3b42e45cc17834138aed0aa71.jpg";